import { CheckCheck, Clock, Hourglass } from 'lucide-react'

import {
  rewardRequestStateLabel,
  type RewardRequestVisibleState
} from '../lib/rewardRequestStatus'

const stateConfig: Record<
  RewardRequestVisibleState,
  { className: string; Icon: typeof CheckCheck }
> = {
  redeemed: { className: 'bg-green-100 text-green-700', Icon: CheckCheck },
  awaiting_pickup: { className: 'bg-blue-100 text-blue-700', Icon: Clock },
  pending_approval: {
    className: 'bg-amber-100 text-amber-700',
    Icon: Hourglass
  }
}

interface RewardRequestBadgeProps {
  state: RewardRequestVisibleState
  className?: string
  iconSize?: number
}

export const RewardRequestBadge = ({
  state,
  className = '',
  iconSize = 14
}: RewardRequestBadgeProps) => {
  const { className: toneClassName, Icon } = stateConfig[state]

  return (
    <span
      className={`inline-flex w-fit items-center gap-1 rounded-full px-2 py-0.5 text-xs font-bold ${toneClassName} ${className}`}
    >
      <Icon size={iconSize} />
      {rewardRequestStateLabel[state]}
    </span>
  )
}
